import {post} from 'aws-amplify/api';
import {Command, type PostMethod} from '../../Command';
import type {UnlinkLinkedInAccountUserResponse} from '../../../dto/user/UnlinkLinkedInAccountUserResponse';

export class UnlinkLinkedInAccountUserCommand extends Command<PostMethod, UnlinkLinkedInAccountUserResponse> {
  constructor() {
    super(post, {
      path: '/linkedinAccessToken/unlink',
    });
  }

  async deserialize(output: ReturnType<typeof post>): Promise<UnlinkLinkedInAccountUserResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<UnlinkLinkedInAccountUserResponse>);
  }
}
